export const cv = [
  {
    id: 1,
    title: "Master's in Islamic Studies",
    subtitle: "Al-Jamiah Ahliah Darul Uloom Moinul Islam",
    date: "2017 - 2018",
    description: "I completed my graduation from this University in 2018.",
    category: "education",
  },

  {
    id: 2,
    title: "CSE Fundamentals Course",
    subtitle: "Programming Hero",
    date: "2021 - 2023",
    description:
      "This is a comprehensive course designed to provide a solid foundation in computer science concepts. Throughout the course, I’ve developed a good understanding of Data Structures and Algorithms. I learned about different algorithmic approaches and techniques, such as sorting, searching etc. I also gained proficiency in Python programming. In the final part of the course, I have explored the Django framework. With Django, I have learned to create web applications that can handle complex data models and provide dynamic content to users. Overall, this course has provided me a solid understanding of computer science concepts and practical programming skills.",
    category: "education",
  },

  {
    id: 3,
    title: "Fullstack Web Development Course",
    subtitle: "Programming Hero",
    date: "2020",
    description:
      "In this course, I have learned to build dynamic and responsive web applications from scratch, starting with basic HTML, CSS and Javascript concepts and progressing to advanced technologies such as React.js, server-side scripting with Node.js and data modeling with Mongoose and MongoDB. Throughout the course, I have developed several projects, including building a full-stack internet service providing website.",
    category: "education",
  },

  {
    id: 4,
    title: "Senior Shopify Developer",
    subtitle: "Webverse",
    date: "01/2025 - Present",
    description:
      "As a Senior Shopify Developer, I build, customize, and optimize Shopify themes to deliver high-performing, user-friendly storefronts. My work includes developing custom themes, sections, integrating dynamic product features, optimizing site performance, and ensuring full responsiveness across devices.",
    category: "experience",
  },
  {
    id: 5,
    title: "Shopify and MERN Stack Developer",
    subtitle: "Exonext Ltd.",
    date: "12/2023 - 11/2024",
    description:
      "At Exonext, I worked on building and customizing Shopify themes while also contributing to MERN stack projects. My role involved developing reusable custom Shopify sections, and ensuring seamless functionality across storefronts. On the MERN side, I collaborated on web applications using React, Next.js and Node.js — This dual role strengthened my ability to bridge Shopify’s ecosystem with modern web technologies.",
    category: "experience",
  },
  {
    id: 6,
    title: "Web Developer",
    subtitle: "F. A. Creative Firm Ltd.",
    date: "04/2023 - 11/2023",
    description:
      "During my time at F. A. Creative Firm Ltd., I worked as a Web Developer, playing a key role in developing two SaaS-based web applications — an HRMS system and a Microfinance management platform. Both projects were built to deliver secure and high-quality website support to prospective clients in need of these solutions. While I collaborated with other developers, I was fully responsible for the front-end development of both projects using React.js and Next.js, ensuring clean UI, responsive layouts, and smooth user experience. Alongside that, I also contributed to the back-end development using Node and Express.js, integrating RESTful APIs and managing database interactions with MongoDB and MySQL.",
    category: "experience",
  },

  {
    id: 7,
    title: "Mern Stack Trainee",
    subtitle: "Zorg It Group",
    date: "12/2021 - 03/2022",
    description:
      "I worked at this company as a MERN Stack Developer trainee. Here other members of our team and I have collaboratively completed multiple projects. One of them is the 'Arcon Interior' project. The project aimed to deliver the best quality and secure website support to the Arcon Interior Firm.",
    category: "experience",
  },

  {
    id: 8,
    title: "Fronend Developer",
    subtitle: "Techneous",
    date: "06/2021 - 12/2021",
    description:
      "I was responsible for developing the front-end part of a project. Here I developed several projects using HTML, CSS, Bootstrap, Tailwind CSS, and Javascript. Two noteworthy projects I've developed and been involved with are machbazaar.com (an e-commerce platform offering a wide range of fresh fish items) and hasbiacademi.com (an educational platform dedicated to providing accessible Islamic religious content and resources).",
    category: "experience",
  },
];
